import { Button, Divider, Drawer, Typography } from "antd";
import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

const MerchantReading = ({
  open,
  close,
  totalGross,
  totalDineIn,
  totalTakeOut,
  totalPickup,
  totalCash,
  totalECash,
  data,
  dateFrom,
  dateTo,
}) => {
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
    },
  });

  return (
    <Drawer
      title="Transaction Reading"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {data.ready && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingRight: 15,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Date From:{" "}
                {moment
                  .utc(new Date(dateFrom))
                  .format("MMMM DD, YYYY 00:00:00")}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginBottom: 10,
                }}
              >
                Date To:{" "}
                {moment.utc(new Date(dateTo)).format("MMMM DD, YYYY 23:59:00")}
              </Typography>
              <Divider />
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Transaction
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                }}
              >
                Dine-In:{" "}
                {parseFloat(totalDineIn).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                }}
              >
                Take-Out:{" "}
                {parseFloat(totalTakeOut).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                Pick Up:{" "}
                {parseFloat(totalPickup).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Senders
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                }}
              >
                Cash:{" "}
                {parseFloat(totalCash).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                E-Cash:{" "}
                {parseFloat(totalECash).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  marginBottom: 10,
                }}
              >
                Customer Count: {data.data.length}
              </Typography>
              <Divider style={{ margin: 0 }} />

              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Total:{" "}
                {parseFloat(totalGross).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", marginTop: 10 }}>
            <div style={{ flexGrow: 1 }} />
            <div>
              <Button
                type="primary"
                onClick={handlePrint}
                icon={<PrinterOutlined />}
              >
                Print
              </Button>
            </div>
          </div>
        </>
      )}
    </Drawer>
  );
};

export default MerchantReading;
